angular
.module('jv.candidate.send.video.invite.modal.controller',[])
.controller('CandDetailsSendInviteReminderModalCtrl', ['$scope', '$routeParams', '$rootScope', '$filter', 'candidates', 'videoService',
function($scope, $routeParams, $rootScope, $filter, candidates, videoService) {
    $scope.$on('hidingVideoModals', function(e, val) {
        $scope.cleanModal();
    });

    $scope.cleanModal = function() {
        $scope.submitted = false;
        $scope.vidTemplates = {};
        makePristine($scope.sendVideoInterviewReminderForm, $('form[name="sendVideoInterviewReminderForm"]'));
    };

    /*
     * TODO-PRANAV: Copying this from jv.ReqsNotesCtrl.js beacuse Candidate Details Page is using
     * Angular 1.0.1 and setPristine is available in 1.1.* onwards. Once we upgrade will not need this code.
     * So dont want to invest time in making code resuable etc.
     * This function makes the form pristine(setting to initial state of the form).
     */
    var makePristine=function(formCtrl,elem) {
        var name;
        if (formCtrl && formCtrl.$name) {
            name = $filter('uppercase')(formCtrl.$name.charAt(0)) + formCtrl.$name.substr(1);
            if(elem){
                // new version of angular has $setPristine, use when available
                if (formCtrl.$setPristine) {
                    formCtrl.$setPristine();
                }
                else {
                    elem.removeClass('ng-dirty').addClass('ng-pristine');
                    formCtrl.$pristine = true;
                    formCtrl.$dirty = false;
                    angular.forEach(elem.find('.ng-dirty'), function(el) {
                        var inputCtrl = $(el).data('$ngModelController');
                        inputCtrl.$pristine = true;
                        inputCtrl.$dirty = false;
                        $(el).removeClass('ng-dirty').addClass('ng-pristine');
                    });
                }
            }
        }
    };

    $scope.checkIfReadyToShow = function() {
        if ($scope.vidTemplates.messageTemplates) {
            $scope.modal.sendReminder = true;
            $scope.flags.loading = false;
        }
    }

    $scope.$on('sendReminderModalCtrl', function(event, id) {
        $scope.SId = id;
        //TODO-PRANAV: Needs to be updated with the new endpoint.
        videoService.sendVideoInterviewReminderTemplate({formID: $scope.SId}, function(res) {
            var templates = [];
            res.resultList = $scope.select2Options.setTemplates(res.resultList);
            angular.forEach(res.resultList, function(template){
                if (template['default']) {
                    $scope.vidTemplates = $scope.vidTemplates || {};
                    $scope.vidTemplates.messageTpl = template;
                    $scope.content = template.body;
                    $scope.subject = template.subject;
                }
                templates.push(template);
            });
            $scope.vidTemplates.messageTemplates = templates;
            $scope.checkIfReadyToShow();
        });

    });

    $scope.sendInviteReminderMessage = function(form,index){
        var videoForm = {};
        videoForm.applicationEIds = $scope.applicationId;
        videoForm.subject = $scope.subject;
        videoForm.message = $scope.content;
        videoForm.formID = $scope.SId;

        var data = '';
        /* Validation*/
        if ($scope.sendVideoInterviewReminderForm.$invalid) {
            return;
        }

        /*This is to escape the special characters */
        var formContent = encodeURIComponent(videoForm.content);
        var formSubject = encodeURIComponent(videoForm.subject);

        /*BE expects locale to be sent to determine language for Email header/footer*/
        if($scope.vidTemplates && $scope.vidTemplates.messageTpl){
            videoForm['locale'] = $scope.vidTemplates.messageTpl['locale'];
        }
        $scope.flags.loading = true;
        videoService.sendVideoInterviewReminder(videoForm, function(data) {
            $scope.flags.loading = false;
            if (data.status === 'ok') {
                $scope.modal.sendReminder=false;
                $scope.cleanModal();
                //TODO-PRANAV: How do we Internationalize this?
                $scope.showMsg('JV_CAND_DETAILS_SENDREMINDER_VIDEO_INTERVIEW_REMINDER_SENT');
            }else if(data.error === 400){
                //TODO: Need to handle this scenario properly(product input). Presently it is broken. We were not showing the processing state to the user as it was confusing. We decided to not show the processing state and
                // show it as if the js has not taken the interview.
                $scope.showMsg('JV_CAND_DETAILS_SENDREMINDER_VIDEO_INTERVIEW_REMINDER_NOT_SENT_');
            }
        });
    };
}]);